import { decorate, observable } from "mobx";
import ForgeVideoPost from "../models/ForgeVideoPost";
import SendToForgeDialogStore from "./SendToForgeDialogStore";

import { toast } from "react-toastify";

class QuickerClipForgeStore extends SendToForgeDialogStore {
  isSendingClipToForge = false;

  async initFields(partialClip, commonClipSearchMetadata) {
    try {
      this.resetDestinations();
      const commonFields = await this.pitsApi.getCommonFields(
        partialClip.playIds
      );

      this.forgeVideoPost = new ForgeVideoPost(partialClip, commonFields, null);

      this.createTags(commonClipSearchMetadata);
    } catch (err) {
      console.log(err);
      alert("Problem initializing fields, please try again.");
    }
  }

  async sendClipToForge(videoId) {
    this.isSendingClipToForge = true;
    const playbackOptions = await this.getPlaybackOptions(videoId);
    this.clip = this.clipsToSearch.find(clip => clip.videoId === videoId);

    if (this.clip) {
      this.forgeVideoPost.playbackOptions = playbackOptions;
      this.forgeVideoPost.videoId = this.clip.videoId;
      this.forgeVideoPost.videoUrl = this.clip.url;
      await this.sendVideo();
    } else {
      toast.error("Clip to send not found", {
        position: "top-right",
        autoClose: 3000
      });
    }

    this.reset();
    this.forgeVideoPost = {};
    this.isSendingClipToForge = false;
  }

  async getPlaybackOptions(videoId) {
    const response = await this.clippyApi.getOutputTypes(videoId);
    const { linksByType } = response;
    return linksByType.map(linkByType => {
      return {
        clipOutputType: linkByType.videoType,
        url: linkByType.link
      };
    });
  }

  setForgeTitle(title) {
    this.forgeVideoPost.videoTitle = title;
  }
}

decorate(QuickerClipForgeStore, {
  isSendingClipToForge: observable
});

export default QuickerClipForgeStore;



// WEBPACK FOOTER //
// ./src/stores/QuickerClipForgeStore.js